import { createFileRoute, Navigate, Outlet } from "@tanstack/react-router";
import { Zap } from "lucide-react";
import { useCurrentTenant } from "@/hooks/use-session";

export const Route = createFileRoute("/_app/speed-to-lead")({
  staticData: {
    title: "Speed to Lead",
    breadcrumb: "Speed to Lead",
    breadcrumbIcon: Zap,
    breadcrumbLink: false,
  },
  component: SpeedToLeadLayout,
});

function SpeedToLeadLayout() {
  const tenant = useCurrentTenant();

  if (!tenant.modules?.includes("speed_to_lead")) {
    return <Navigate to="/" />;
  }

  return <Outlet />;
}
